import { useRef, useState } from 'react'

import { FormikAutocomplete } from 'Components/UI/Atoms/CustomAutocomplete'
//import { exportClientsValidation } from "Components/Validation/Sales/Clients"
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithValidate from 'Components/UI/Molecules/InputsWithValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { Form, Formik } from 'formik'
import { interfaces } from 'service/interfaces'

const ExportClients = ({ open, onClose }) => {
  const [loading, setLoading] = useState(false)
  const createDismissableSnackbar = useCustomSnackbar()
  const formikRef = useRef(null)

  const handleSubmit = () => {
    formikRef.current.submitForm()
  }

  const exportData = async (values) => {
    setLoading(true)
    const empresaId = values.origen?.id || values.origen
    const body = { empresa: empresaId }

    await interfaces.salesClients
      .exportDataClients(body)
      .then((res) => {
        window.location.assign(res.data)
        createDismissableSnackbar('¡Datos de clientes exportados!', {
          variant: 'success',
        })
        onClose()
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal al exportar datos!', {
          variant: 'error',
        })
      })
    setLoading(false)
  }

  const exportBalances = async (values) => {
    setLoading(true)
    const date = new Date(values.final)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const formattedFinalDate = `${year}-${month}-${day}`

    const empresaId = values.origen?.id || values.origen
    const body = {
      empresa: empresaId,
      inicio: '2000-01-01',
      final: formattedFinalDate,
    }

    await interfaces.salesClients
      .exportClients(body)
      .then((res) => {
        window.location.assign(res.data)
        createDismissableSnackbar('¡Saldos de clientes exportados!', {
          variant: 'success',
        })
        onClose()
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal al exportar saldos!', {
          variant: 'error',
        })
      })
    setLoading(false)
  }

  const onSubmit = (values) => {
    if (values.tipo === 1) {
      exportData(values)
    } else if (values.tipo === 2) {
      exportBalances(values)
    }
  }

  const enteprises = [
    { id: 1, label: 'ECO' },
    { id: 2, label: 'OEM' },
    { id: 3, label: 'DOS' },
  ]
  const type = [
    { id: 1, label: 'Datos clientes' },
    { id: 2, label: 'Saldo clientes' },
  ]

  const today = new Date()

  const fields = (setFieldValue, values) => [
    {
      class: 'custom',
      component: (
        <FormikAutocomplete
          label="Origen"
          name="origen"
          defaultValue={{ id: 1, label: 'ECO' }}
          options={enteprises}
          getOptionLabel={(e) => e.label}
          onChange={(_, value) => {
            setFieldValue('origen', value.id)
          }}
        />
      ),
      sm: 12,
      xs: 12,
    },
    {
      class: 'custom',
      component: (
        <FormikAutocomplete
          label="Tipo"
          name="tipo"
          options={type}
          defaultValue={{ id: 1, label: 'Datos clientes' }}
          getOptionLabel={(e) => e.label}
          onChange={(_, value) => {
            setFieldValue('tipo', value.id)
          }}
        />
      ),
      sm: 12,
      xs: 12,
    },
    {
      class: 'datepicker',
      label: 'Fecha final',
      format: 'dd-MM-yyyy',
      name: 'final',
      value: today,
      sm: 12,
      xs: 12,
      disabled: values.tipo === 1 ? true : false,
    },
  ]

  return (
    <DialogComponent
      open={open}
      handleclose={onClose}
      title="Exportar saldo de clientes o proveedores"
      disableBackdropClick={true}
      handleclosedisabled={loading}
      disableChildHeight
      disableEscapeKeyDown
      widthLarge="500px"
      actions={
        <CancelConfirmButtons
          onClickSubmit={handleSubmit}
          onClickCancel={onClose}
          disabledCancel={loading}
          disabledSubmit={loading}
          isLoading={loading}
        />
      }
      children={
        <Formik
          innerRef={formikRef}
          initialValues={{
            origen: { id: 1, label: 'ECO' },
            tipo: 1,
            final: today,
          }}
          onSubmit={onSubmit}
          enableReinitialize
          //validationSchema={exportClientsValidation}
        >
          {({ setFieldValue, values }) => (
            <Form>
              <InputsWithValidate
                fields={fields(setFieldValue, values)}
                spacing={2}
                setFieldValue={setFieldValue}
              />
            </Form>
          )}
        </Formik>
      }
    />
  )
}

export default ExportClients
